import { mutatorAction } from "satcheljs";
import { getConditionalFormattingStore } from "../store/store";
import type { ConditionalFormattingPreviewRenderer } from "../store/schema/ConditionalFormattingStore";
import type { MailboxInfo } from "owa-client-types";

const registerConditionalFormattingPreviewRendererMutator: (mailboxInfo: MailboxInfo, renderer: ConditionalFormattingPreviewRenderer) => void = mutatorAction("registerConditionalFormattingPreviewRendererMutator", (mailboxInfo: MailboxInfo, renderer: ConditionalFormattingPreviewRenderer): void => {
    const store = getConditionalFormattingStore(mailboxInfo, "Mail");
    store.previewRenderer = renderer;
});

export default registerConditionalFormattingPreviewRendererMutator;
